import Stack from '@perpay-web/components/design-system/Stack/Stack';
import phoSignupCardSrc from '@perpay-web/fintech/assets/images/phoSignupCardSrc.png';
import phoSilverSignup from '@perpay-web/fintech/assets/images/phoSilverSignup.png';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './PartnerHostedOnboardingValueProp.scss';

const PartnerHostedOnboardingValueProp = ({
    welcomeOffer,
    isUserInPremiumGroup = false,
}) => (
    <div
        className={getClassName(
            styles.container,
            welcomeOffer ? styles.container__bonus : '',
        )}
    >
        {welcomeOffer ? (
            <div className={styles['welcome-offer']}>
                ${welcomeOffer} Welcome Bonus
            </div>
        ) : null}
        <div className={styles.section}>
            <div className={styles.section__left}>
                <img
                    className={styles.image}
                    src={
                        isUserInPremiumGroup
                            ? phoSilverSignup
                            : phoSignupCardSrc
                    }
                    alt='Perpay Card'
                />
            </div>
            <div className={styles.section__right}>
                <Stack className={styles.stack}>
                    <div className={styles.list__item}>
                        <div className={styles.list__icon} />
                        <div className={styles.list__text}>
                            Access up to a{' '}
                            <span className={styles.semi}>$1,500</span> starting
                            credit limit
                        </div>
                    </div>
                    <div className={styles.list__item}>
                        <div className={styles.list__icon} />
                        <div className={styles.list__text}>
                            <span className={styles.semi}>
                                Build your credit
                            </span>{' '}
                            with payroll direct deposit
                        </div>
                    </div>
                    <div className={styles.list__item}>
                        <div className={styles.list__icon} />
                        <div className={styles.list__text}>
                            <span className={styles.semi}>
                                Earn 2% rewards
                                <sup className={styles['disclaimer-footnote']}>
                                    1
                                </sup>
                            </span>
                        </div>
                    </div>
                </Stack>
            </div>
        </div>
    </div>
);

export default PartnerHostedOnboardingValueProp;
